import React from 'react';
import { Form, TextArea } from 'semantic-ui-react';
import { withNamespaces } from 'react-i18next';


const User = (props) => {
  const { data, t } = props;
  
  return (
    <div>
      <Form.Field
        width={16}
        required
        control={TextArea}
        label={t('private:addWorkshop.previousExperience')}
        placeholder={t('private:addWorkshop.previousExperience_i')}
        name='previousExperience'
        value={data.previousExperience}
        onChange={props.onChange}
      />
      <Form.Field
        width={16}
        required
        control={TextArea}
        label={t('private:addWorkshop.informationSource')}
        placeholder={t('private:addWorkshop.informationSource_i')}
        name='informationSource'
        value={data.informationSource}
        onChange={props.onChange}
      />
    </div>
  );
};

export default withNamespaces(['private'])(User);




// WEBPACK FOOTER //
// ./src/private/common/components/Workshop/Form/Extra/index.js